import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";

import { ISectionSchema } from "../../services/Schemas/Role";
import AccessTableComponent from "../../components/panel/accesses/AccessesTable";
import CreateAccessModal from "../../components/panel/accesses/CreateAccessModal";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import { useNotificationContext } from "../../context/notificationContext";
import { SectionListRequest } from "../../services/Endpoints/sections/SectionsListEndpoint";
import errorResolver from "../../utils/error-resolver";
import { AccessEnums } from "../../constants/accessEnum";
import { useCanAccess } from "../../hooks/canAccess";

export default function AccessManagePage() {
  const [walletReload, setWalletReload] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [roleInfo, setRoleInfo] = useState<ISectionSchema | undefined>(
    undefined
  );

  const [waiting, setWaiting] = useState(false);
  const { can } = useCanAccess();

  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();

  const onClose = (payload: boolean) => {
    setOpenModal(payload);
    setRoleInfo(undefined);
  };

  const handleSync = async () => {
    try {
      setWaiting(true);
      const contactUpdateRequest = new SectionListRequest(protectedInstance);
      const resp = await contactUpdateRequest.syncWithRoutes();
      setWalletReload(!walletReload);
    } catch (error) {
      console.error(error);
      errorResolver({ error, setNotification });
    } finally {
      setWaiting(false);
    }
  };

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                دسترسی ها
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                لیست دسترسی ها
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            >
              <Button
                variant="contained"
                disabled={!can(AccessEnums.AdminAclSectionsCreate)}
                onClick={() => setOpenModal(true)}
              >
                ایجاد دسترسی
              </Button>
              <Button
                variant="outlined"
                disabled={!can(AccessEnums.AdminAclSectionsSyncWithRoutes)}
                onClick={handleSync}
              >
                هماهنگ سازی
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <AccessTableComponent
          walletReload={walletReload}
          setWalletReload={setWalletReload}
          setOpenModal={setOpenModal}
          setRoleInfo={setRoleInfo}
        />
        <CreateAccessModal
          onClose={onClose}
          handleReload={() => setWalletReload(!walletReload)}
          open={openModal}
          roleInfo={roleInfo}
        />
      </Stack>
    </>
  );
}
